import Axios from 'axios'
import { cloneDeep, merge } from 'lodash'
import signMethods from '@/plugin/signJSFCrypto'
import { SignData } from 'nb-vue-wbs-common/sign'
import { Message } from 'nb-vue-element'
import moment from 'moment'
import { getLoading, endLoading, errorLoading } from 'nb-vue-wbs-common/loading'
import store from '@/store'
import Env from '@/plugin/defineEnv'
import PUBLICKEY from '@/plugin/commonData'
const { JSFCrypto } = signMethods
console.log(Env)
const VUE_APP_PUBLICKEY = PUBLICKEY
const jsfCrypto = new JSFCrypto(VUE_APP_PUBLICKEY)
// 请求拦截
Axios.interceptors.request.use(
  config => {
    // 处理直接调用嘉实接口的逻辑
    if (config.headers.jiashi_new === 'true') {
      // 测试环境不加密
      if (Env !== 'test') {
        config.data = jsfCrypto.encrypt(config.data)
      }
    }
    // 给http请求url添加API name参数，方便开发时查看定位api
    // /http/开头的旧api不做处理
    const token = store.state.user.token ? store.state.user.token : ''
    if (config.data && config.data.name) {
      const $symbol = config.url.indexOf('?') > -1 ? '&_=' : '?_='
      config.url += $symbol + config.data.name
    }
    // 请求头中添加token
    if (token) {
      config.headers.token = token
    }
    if (config.headers.api_new === 'true') {
      let _data = {}
      _data.timestamp = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      _data.app_key = 'test'
      _data.format = 'json'
      _data.version = ''
      _data = merge(_data, config.data)
      _data.data = encodeURIComponent(JSON.stringify(_data.data))
      _data.sign = SignData.signNew(_data)
      config.data = _data
    }
    if (config.headers.api_new_json === 'true') {
      const _data = new FormData()
      _data.append('data', JSON.stringify({ param: cloneDeep(config.data) }))
      config.data = _data
    }
    if (config.loading !== false) {
      getLoading(config)
    }
    // Just For Dev & Test
    if (process.env.NODE_ENV === 'development') {
      if (config.url.indexOf('service-wbs310') > -1) {
        config.url = config.url.replace(
          'https://service-wbs310.newtamp.cn',
          ''
        )
      }
    }

    return config
  },
  err => {
    return Promise.reject(err)
  }
)
// 请求结束
Axios.interceptors.response.use(
  response => {
    if (response.config.loading !== false) {
      endLoading(response)
    }
    // 判断返回值是否需要解码(测试环境无需解码)
    if (Env !== 'test') {
      if (response.data && response.data.sign) {
        response.data = jsfCrypto.decrypt(response.data)
      }
    }
    if (response.headers.sessionkey) {
      return { value: response.data, sessionkey: response.headers.sessionkey }
    }
    return response.data
  },
  error => {
    errorLoading()
    Message.error(error.toString())
    return Promise.reject(error)
  }
)
export default Axios
